import React, { useState, useEffect } from 'react';
import { Box, Autocomplete, TextField, Typography, List, Stack, Tooltip, Paper } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import HelpIcon from '@mui/icons-material/Help';
import AppBar from '@mui/material/AppBar';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import PermMediaRoundedIcon from '@mui/icons-material/PermMediaRounded';
import TocRoundedIcon from '@mui/icons-material/TocRounded';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';

import Primarytheme from './utility/theme';
import ProjectInfoChart from './utility/ProjectInfoChart';

import { getSessionIdToken } from './auth/apiAuth'

import axios from 'axios';

const {
    REACT_APP_USER_ID,
} = process.env;

export default function ProjectInfo({ auth }) {

    // creare pagina grande con grafici impaginazioni

    // state project
    const [attachedProjects, setAttachedProjects] = useState(auth.userState.attached_projects);
    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedPrefix, setSelectedPrefix] = useState({ prefix: undefined, space: undefined, maxSpace: undefined, exclude_folders_gb_limit_total: undefined });
    const [selectedAssetPrefix, setSelectedAssetPrefix] = useState({ prefix: undefined, sharedProjectId: undefined, space: undefined, maxAssetSpace: undefined, exclude_folders_gb_asset_limit: undefined });
    const [getRowLimit, setRowLimit] = useState(null);
    const [getImageLimit, setImageLimit] = useState(null);
    const [conf, setConf] = useState({});

    // fecth projects when open dialog
    useEffect(() => {
        if (auth.userState.userItem) {
            const flagAllProjects = auth.userState.isAdmin || auth.userState.type === 'billing';
            if (flagAllProjects) {
                fetchConf({})
                    .then(response => {
                        setAttachedProjects(response.data.projectsList
                            .filter(el => !el.is_labels)
                            .map(el => `${el.customer}/${el.project_name}`))
                    });
            } else {
                setAttachedProjects(auth.userState.attached_projects)
                if (attachedProjects.length === 1) {
                    handleChangeProject(undefined, attachedProjects[0])
                }
            }
        }
    }, []);

    const handleChangeProject = (event, value) => {
        if (!value) {
            // rest all states
            setSelectedPrefix({ prefix: undefined, space: undefined, maxSpace: undefined, exclude_folders_gb_limit_total: undefined });
            setSelectedAssetPrefix({ prefix: undefined, sharedProjectId: undefined, space: undefined, maxAssetSpace: undefined, exclude_folders_gb_asset_limit: undefined });
            setSelectedProject(null);
            setImageLimit(null);
            setRowLimit(null);
            setConf({});
        }
        else {
            setSelectedProject(value);
            setSelectedPrefix({ prefix: `documents.pagination.com/${value}`, space: 'in-progress', maxSpace: undefined, exclude_folders_gb_limit_total: undefined });
            setSelectedAssetPrefix({ prefix: `documents.pagination.com/${value}`, space: 'in-progress', maxAssetSpace: undefined, exclude_folders_gb_asset_limit: undefined, sharedProjectId: undefined });

            setRowLimit(null);
            setImageLimit(null);

            // fetch conf
            fetchConf({ project_id: value })
                .then(response => {
                    const projectConf = response.data.projectConf;
                    setConf(projectConf);

                    const bucket = projectConf.bucket ? projectConf.bucket : 'documents.pagination.com';
                    const maxSpace = (projectConf.gb_limit_total && projectConf.gb_limit_total !== 'no limit') ? projectConf.gb_limit_total : undefined;
                    const maxAssetSpace = (projectConf.gb_asset_limit && projectConf.gb_asset_limit !== 'no limit') ? projectConf.gb_asset_limit : undefined;
                    const imageLimit = (projectConf.image_limit && projectConf.image_limit !== 'no limit') ? projectConf.image_limit : undefined;
                    const rowLimit = (projectConf.row_limit && projectConf.row_limit !== 'no limit') ? projectConf.row_limit : undefined;

                    const exclude_folders_gb_limit_total = (projectConf.exclude_folders_gb_limit_total && projectConf.exclude_folders_gb_limit_total.length) ? projectConf.exclude_folders_gb_limit_total : undefined;
                    const exclude_folders_gb_asset_limit = (projectConf.exclude_folders_gb_asset_limit && projectConf.exclude_folders_gb_asset_limit.length) ? projectConf.exclude_folders_gb_asset_limit : undefined;

                    let sharedProjectId = undefined;
                    if (projectConf.shared_folders) sharedProjectId = projectConf.shared_folders;

                    getPrefixSpace({ prefix: `${bucket}/${value}`, sharedProjectId, maxSpace, maxAssetSpace, imageLimit, rowLimit, exclude_folders_gb_limit_total, exclude_folders_gb_asset_limit })
                        .then(responseSpace => {
                            console.log('calculate-space-response');
                        })

                });

        }
    };

    const getPrefixSpace = async ({ prefix, sharedProjectId, maxSpace, maxAssetSpace, imageLimit, rowLimit, exclude_folders_gb_limit_total, exclude_folders_gb_asset_limit }) => {
        return axios.get(`${process.env.REACT_APP_API_BASE_URL}/assets`, {
            headers: {
                'user_id': auth.userState.user,
                "content-type": "application/json",
                "Authorization": await getSessionIdToken(),
                "prefix": prefix,
                "exclude_folders_gb_limit_total": exclude_folders_gb_limit_total,
                "exclude_folders_gb_asset_limit": exclude_folders_gb_asset_limit,
                "shared_projectid": sharedProjectId,
            },
        }).then(response => {
            setSelectedPrefix({ prefix, space: response.data.spaceFolder, maxSpace, exclude_folders_gb_limit_total });
            setSelectedAssetPrefix({ ...selectedAssetPrefix, prefix, sharedProjectId, space: response.data.spaceAssetFolder, maxAssetSpace, exclude_folders_gb_asset_limit })
            // update state
            setImageLimit(imageLimit);
            setRowLimit(rowLimit);

            return 'calculate-sapce-done'
        }).catch(err => {
            console.error('calculate-space-error');
            setSelectedPrefix({ prefix, space: 'More than 50', maxSpace, exclude_folders_gb_limit_total });
            // update state
            setImageLimit(imageLimit);
            setRowLimit(rowLimit);
            return 'too many files'
        });
    }

    const fetchConf = async ({ project_id }) => {
        const token = await getSessionIdToken()
        if (project_id) {
            const [customer, project_name] = project_id.split('/').slice(0, 2);

            //console.log(auth.userState.email)
            return axios.get(`${process.env.REACT_APP_API_BASE_URL}/projects-webapp`,
                {
                    headers: {
                        'user_id': auth.userState.user,
                        "content-type": "application/json",
                        "Authorization": token,
                        "project_id": project_id,
                        "project_name": project_name,
                        "customer": customer,
                    }

                },
            );
        } else {
            return axios.get(`${process.env.REACT_APP_API_BASE_URL}/projects-webapp`,
                {
                    headers: {
                        'user_id': auth.userState.user,
                        "content-type": "application/json",
                        "Authorization": token,
                        "type": 'project-list',
                    }

                },
            );
        }
    }


    const DataCard = ({ title, desc, icon, quantity, progressVal, error }) => {
        //console.log(title, progressVal)
        return (
            <Paper elevation={3} sx={{ padding: '0.5em', align: 'center', borderRadius: '10px' }}>
                <Box sx={{ marginTop: '1em', marginLeft: '1em', marginRight: '1em', display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                    <Stack direction={'row'}>
                        <Typography variant='h1' sx={{ fontSize: '1.2em', fontWeight: 'bold', }}>{title}</Typography>
                        <Tooltip title={
                            <Typography variant='caption' >
                                {desc}
                            </Typography>}>
                            <HelpIcon sx={{ fontSize: '1.2em', color: Primarytheme.palette.neutral.main, marginLeft: '0.5em' }} />
                        </Tooltip>
                    </Stack>
                    {icon}
                </Box>

                <Box sx={{ marginTop: '1em', marginLeft: '1em', marginRight: '1em' }}>
                    <Typography variant='h2' sx={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                        {quantity}
                    </Typography>
                </Box>

                {progressVal !== null ? (
                    <LinearProgress
                        variant="determinate"
                        value={progressVal}
                        sx={{ height: 12, marginTop: '1em', marginBottom: '1em', marginLeft: '1em', marginRight: '1em', borderRadius: '12px' }}
                        color={error}
                    />
                ) : (
                    <Box sx={{height: 12, marginTop: '1em', marginBottom: '1em'}}></Box>
                )}
            </Paper>
        );
    };



    return (
        <Box sx={{ margin: 0 }}>
            <AppBar position="sticky" sx={{ zIndex: 1, }} >
                <Stack direction='row' spacing={2} justifyContent='flex-start' alignItems='center'
                    sx={{ padding: '1em', background: 'white' }}
                >
                    <Autocomplete
                        id="project-selector"
                        options={attachedProjects}
                        sx={{ width: '100%', maxWidth: 600 }}
                        clearOnEscape
                        defaultValue={attachedProjects.length === 1 ? attachedProjects[0] : ''}
                        value={selectedProject}
                        onChange={handleChangeProject}
                        size='small'
                        renderInput={(params) => <TextField {...params} label="project" />}
                    />

                    {selectedPrefix.space && selectedPrefix.space === 'in-progress' && (
                        <CircularProgress size="2em" />
                    )}
                </Stack>
            </AppBar>
            <Grid
                container
                sx={{
                    justifyContent: "flex-start",
                    alignItems: "center",
                    marginTop: '3em',
                    marginBottom: '2em'
                }}
                columns={12}
                columnSpacing={2}
                rowSpacing={4}
                ml={'3em'}
                mr={'3em'}
            >
                {selectedPrefix.space && selectedPrefix.space !== 'in-progress' && (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 3 }}>
                        <DataCard
                            title="Total Used Space"
                            desc="Space used for assets, data and output."
                            icon={
                                <Inventory2RoundedIcon
                                    color={Number(selectedPrefix.space) >= Number(selectedPrefix.maxSpace) ? 'error' : 'primary'}
                                    sx={{ fontSize: '3em', marginLeft: '0.5em' }}
                                />
                            }
                            quantity={
                                <b>
                                    {selectedPrefix.space}
                                    {selectedPrefix.maxSpace ? ` / ${selectedPrefix.maxSpace}` : ''} GB
                                </b>
                            }
                            progressVal={Number(selectedPrefix.space) >= Number(selectedPrefix.maxSpace) ? 100 : (Number(selectedPrefix.space) / Number(selectedPrefix.maxSpace)) * 100}
                            error={Number(selectedPrefix.space) >= Number(selectedPrefix.maxSpace) ? 'error' : 'primary'}
                        />
                    </Grid>
                )}

                {selectedAssetPrefix.maxAssetSpace !== 'no limits' && selectedAssetPrefix.space && Number(selectedAssetPrefix.space) !== 0 && selectedAssetPrefix.space !== 'in-progress' && (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <DataCard
                            title="Asset Used Space"
                            desc={(!selectedAssetPrefix.sharedProjectId) ? "Space used for assets." : "Space used for assets. Including shared folders."}
                            icon={
                                <PermMediaRoundedIcon
                                    color={Number(selectedAssetPrefix.space) >= Number(selectedAssetPrefix.maxAssetSpace) ? 'error' : 'primary'}
                                    sx={{ fontSize: '3em', marginLeft: '0.5em' }}
                                />
                            }
                            quantity={
                                <b>{selectedAssetPrefix.space} {selectedAssetPrefix.maxAssetSpace ? `/ ${selectedAssetPrefix.maxAssetSpace} ` : ''}GB</b>
                            }
                            progressVal={Number(selectedAssetPrefix.space) >= Number(selectedAssetPrefix.maxAssetSpace) ? 100 : isNaN(selectedAssetPrefix.space) ? 0 : (Number(selectedAssetPrefix.space) / Number(selectedAssetPrefix.maxAssetSpace)) * 100}
                            error={Number(selectedAssetPrefix.space) >= Number(selectedAssetPrefix.maxAssetSpace) ? 'error' : 'primary'}
                        />
                    </Grid>
                )}

                {getRowLimit && (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <DataCard
                            title="Row Limit"
                            desc={"Maximum number of rows processed for each requests."}
                            icon={
                                <TocRoundedIcon
                                    color={'primary'}
                                    sx={{ fontSize: '3em', marginLeft: '0.5em' }}
                                />
                            }
                            quantity={
                                <b>{getRowLimit}</b>
                            }
                            progressVal={null}
                            error={'primary'}
                        />
                    </Grid>
                )}

                {getImageLimit && (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <DataCard
                            title="Image Limit"
                            desc={"Maximum number of images processed for each requests."}
                            icon={
                                <ImageRoundedIcon
                                    color={'primary'}
                                    sx={{ fontSize: '3em', marginLeft: '0.5em' }}
                                />
                            }
                            quantity={
                                <b>{getImageLimit}</b>
                            }
                            progressVal={null}
                            error={'primary'}
                        />
                    </Grid>
                )}


                {/* grafico */}
                {selectedProject && selectedPrefix.space && selectedPrefix.space !== 'in-progress' && (
                    <ProjectInfoChart auth={auth} selectedProject={selectedProject} />
                )}


            </Grid>
        </Box >
    )

}
